import { FC, lazy, Suspense, useContext } from 'react';
import { Box } from '@mui/material';
import { GlobalContext } from '../../common/contexts/globalContext';
import Drawer from './components/Drawer/Drawer';
import { IconLogoName, IconLogo } from '../../common/images';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { getUrlQuery } from '../../common/utils/communication';
import { COLORS } from '../../common/constants/constants';

const ReportSidebar = lazy(() => import('./components/ReportSidebar/ReportSidebar'));
const AdminSidebar = lazy(() => import('./components/AdminSidebar/AdminSidebar'));
const CasesSidebar = lazy(() => import('./components/CasesSidebar/CasesSidebar'));

interface SidebarProps {
    isUserAdmin: boolean;
}

const Sidebar: FC<SidebarProps> = ({ isUserAdmin }) => {
    const { uiData } = useContext(GlobalContext);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Drawer
            variant="permanent"
            open={uiData.sidebarIsOpen}
            data-testid="sidebar"
            sx={{
                '& .MuiPaper-root': {
                    overflow: 'unset',
                    backgroundColor: location.pathname.includes('/admin/') ? '#fff' : COLORS.MUTED_SOFT,
                    borderRight: `1px solid ${
                        location.pathname.includes('/admin/') ? COLORS.MUTED_LIGHTEST : COLORS.LIGHT
                    }`,
                },
            }}
        >
            <Box className="background-color-mst" sx={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <Box
                    className="logo-filter"
                    sx={{ mt: 3, mb: 1, px: '20px', cursor: 'pointer' }}
                    onClick={() => navigate(`/collections${getUrlQuery()}`)}
                >
                    {uiData.sidebarIsOpen ? <IconLogoName /> : <IconLogo />}
                </Box>
            </Box>
            <Suspense fallback={<></>}>
                <Routes>
                    <Route path="/collections" element={<CasesSidebar />} />
                    {isUserAdmin && <Route path="/admin/*" element={<AdminSidebar />} />}
                    <Route path="/report/:streamId" element={<ReportSidebar />} />
                    <Route path={`/download-report`} element={<></>} />
                </Routes>
            </Suspense>
        </Drawer>
    );
};

export default Sidebar;
